// extracted by mini-css-extract-plugin
module.exports = {"root":"hero-module--root--1smYT"};